// 中文


export default {
  "环球客": "环球客",
  "登录": "登录",
  "邮箱": "邮箱",
  "密码": "密码",
  "忘记密码": "忘记密码",
  "请确认已达法定成年年龄": "请确认已达法定成年年龄",
  "我已阅读并同意": "我已阅读并同意",
  "服务条款": "服务条款",
  "和": "和",
  "隐私政策": "隐私政策",
  "隐私协议": "隐私协议",
  "使用Google": "使用 Google",
  "使用Facebook": "使用 Facebook",
  "邮箱加入": "邮箱加入",
  "没有账号?": "没有账号？",
  "加入": "加入",
  "注册": "注册",
  "无数据": "无数据",
  "国家": "国家",
  "省份": "省份",
  "城市": "城市",
  "请输入姓名": "请输入姓名",
  "请输入账号": "请输入账号",
  "请输入邮箱": "请输入邮箱",
  "请输入邮箱验证码": "请输入邮箱验证码",
  "请输入密码": "请输入密码",
  "请再次输入密码": "请再次输入密码",
  "获取验证码": "获取验证码",
  "已有账号? 点击登录": "已有账号? 点击登录",
  "已有账号?": "已有账号？",
  "点击登录": "点击登录",
  "APP下载": "APP下载",
  "关于我们": "关于我们",
  "常见问题": "常见问题",
  "联系我们": "联系我们",
  "立即开始": "立即开始",

  "姓名不能为空": "姓名不能为空",
  "地区不能为空": "地区不能为空",
  "账号不能为空": "账号不能为空",
  "邮箱不能为空": "邮箱不能为空",
  "邮箱格式不正确": "邮箱格式不正确",
  "验证码发送成功": "验证码发送成功",
  "邮箱已注册": "邮箱已注册",
  "验证码不能为空": "验证码不能为空",
  "密码不能为空": "密码不能为空",
  "两次密码不一致": "两次密码不一致",
  "密码规则": "密码最少8位,不超过32位 必须同时包括数字，大写字母，小写字母",

  "请确认勾选已达法定年龄": "请确认勾选已达法定年龄",
  "请确认勾选同意协议": "请确认勾选同意协议",

  "登录成功": "登录成功",
  "登录失败": "登录失败",
  "登出成功": "登出成功",
  "登出失败": "登出失败",

  "注册成功": "注册成功",
  "注册成功，请重新登录": "注册成功，请重新登录",

  "服务器错误": "服务器错误",
  "服务器错误，请重试": "服务器错误，请重试",


  "发送失败提示消息": "发送失败，请重试",

  "标题": "标题",
  "请输入标题": "请输入标题",
  "简介": "简介",
  "请输入简介": "请输入简介",
  "视频上传": "视频上传",
  "视频上传限制信息": "建议使用MP4/ MOV视频格式，视频时长不超过1个小时",
  "视频上传大小限制信息": "视频不可超过30G",
  "视频上传数目限制信息": "最多只能上传9个视频",
  "替换视频": "替换视频",
  "图片上传": "图片上传",
  "封面图": "封面图",
  "封面图限制信息": "建议尺寸16*9，支持格式JPG /JPEG /PNG，小于5M",
  "封面图上传大小限制信息": "封面图小于5M",
  "选择标签": "选择标签",
  "请选择标签": "请选择标签",
  "所属地区": "所属地区",
  "国家": "国家",
  "省份": "省份",
  "城市": "城市",
  "上传附件": "上传附件",
  "点击插入附件": "点击插入附件",
  "关联任务": "关联任务",
  "更换": "更换",
  "添加关联任务": "添加关联任务",
  "同意签署": "同意签署",
  "著作权转让协议": "著作权转让协议",
  "保存草稿": "保存草稿",
  "提交": "提交",
  "上传成功": "上传成功",
  "上传失败": "上传失败",
  "必填项未填写提示信息": "必填项未填写",
  "上传中": "上传中...",

  "创建成功": "创建成功",
  "创建失败提示信息": "创建失败，请重试",

  "状态": "状态",
  "全部": "全部",
  "待审核": "待审核",
  "审核退回": "审核退回",
  "已采纳": "已采纳",
  "审核通过": "审核通过",

  "审核中": "审核中",
	"未接收": "未接收",
	"未支付": "未支付",
	"已通过": "已通过",
	"已拒绝": "已拒绝",
	"已接收": "已接收",
	"已支付": "已支付",
	"已提交": "已提交",
	"已驳回": "已驳回",
	"已采纳": "已采纳",
	"已发布": "已发布",
	"Pending": "待审核",
  "已打款": "已打款",

  "封面": "封面",
  "标题": "标题",
  "内容标签": "内容标签",
  "关联活动": "关联活动",
  "提交时间": "提交时间",
  "状态": "状态",
  "审核时间": "审核时间",
  "操作": "操作",

  "编辑": "编辑",
  "删除": "删除",
  "查看详情": "查看详情",
  "作品ID不存在": "作品ID不存在",
  "删除成功": "删除成功",
  "删除失败，请重试": "删除失败，请重试",

  "提示": "提示",
  "确认": "确认",
  "确定": "确定",
  "取消": "取消",
  "确认删除该作品": "确认删除该作品？",

  "选择任务": "选择任务",
  "加载更多": "加载更多",
  "没有更多了": "没有更多了",
  "暂无数据": "暂无数据",
  "加载中": "加载中...",
  "加载中新": "加载中",

  "账号设置": "账号设置",
  "认证情况": "认证情况",
  "昵称": "昵称",
  "账号": "账号",
  "邮箱": "邮箱",
  "姓名": "姓名",
  "简介": "简介",
  "标签": "标签",

  "修改头像": "修改头像",
  "未提交认证": "未提交认证",
  "认证通过": "认证通过",
  "认证失败": "认证失败",
  "去认证": "去认证",

  "修改": "修改",
  "设置": "设置",
  "最多5个标签": "最多5个标签",
  "头像设置要求": "尺寸为200*200像素，能代表个人、机构或品牌形象，请勿使用低俗图片、二维码、其他机构企业等涉嫌误导用户的头像",
  "个人简介要求": "1～140个字符",

  "修改简介": "修改简介",
  "修改简介说明": "对读者描述拍客号定位或作者简介，简介将显示在媒体主页，请勿发布个人手机号码、邮箱、广告营销信息，请勿超过100字",
  "播放视频": "播放视频",

  "谷歌登录错误提示信息一": "登录窗口未显示。可能是弹窗被浏览器阻止，或其他配置问题。",
  "谷歌登录错误提示信息二": "用户跳过了登录。请重新尝试。",
  "谷歌登录错误提示信息三": "登录时发生未知错误，请稍后再试。",

  "作品详情": "作品详情",
  "审核中": "审核中",
  "未接收": "未接收",
  "未支付": "未支付",
  "已通过": "已通过",
  "已拒绝": "已拒绝",
  "已接收": "已接收",
  "已支付": "已支付",
  "已提交": "已提交",
  "已驳回": "已驳回",
  "已采纳": "已采纳",
  "下载审核意见附件": "下载审核意见附件",
  "标签": "标签",
  "附件": "附件",
  "修改成功": "修改成功",
  "修改失败提示信息": "修改失败，请重试",

  "开始截止时间": "开始截止时间",
  "截止时间": "截止时间",
  "剩余天数": "剩余天数",
  "任务积分": "任务积分",
  "任务状态": "任务状态",
  "天": "天",
  "已上架": "已上架",
  "已下架": "已下架",
  "上传作品": "上传作品",

  "提交线索": "提交线索",
  "我的线索": "我的线索",
  "确认删除该线索": "确认删除该线索",

  "线索详情": "线索详情",

  "著作权转让协议": "著作权转让协议",

  "个人主页": "个人主页",
  "EN": "EN",
  "中": "中",
  "退出登录": "退出登录",

  "创作": "创作",
  "作品发布": "作品发布",
  "我的作品": "我的作品",
  "作品详情": "作品详情",
  "任务": "任务",
  "我的任务": "我的任务",
  "任务详情": "任务详情",
  "线索": "线索",
  "提交线索": "提交线索",
  "我的线索": "我的线索",
  "线索详情": "线索详情",
  "设置": "设置",

  "认证提交成功": "认证提交成功",
  "我们已收到您的认证信息，感谢您提交认证": "我们已收到您的认证信息，感谢您提交认证",
  "关闭": "关闭",
  "认证信息": "认证信息",
  "邮箱": "邮箱",
  "姓名": "姓名",
  "出生年月": "出生年月",
  "选择日期": "选择日期",
  "上传简历": "上传简历",
  "仅支持文件格式": "*仅支持doc/txt/pdf格式文件",
  "所在地": "所在地",
  "确认": "确认",
  "设置姓名": "设置姓名",
  "修改昵称": "修改昵称",
  "现昵称": "现昵称",
  "新昵称": "新昵称",
  "请输入昵称": "请输入昵称",
  "不超过32个字符，不能含有特殊符号、空格": "不超过32个字符，不能含有特殊符号、空格",
  "新标签": "新标签",

  "寻找拍客": "寻找拍客",
  "在全球118个国家寻找适合您的专业拍客，发布您的拍摄任务，管理任务进度请联系": "在全球118个国家寻找适合您的专业拍客，发布您的拍摄任务，管理任务进度请联系",
  "成为拍客": "成为拍客",
  "与更多品牌合作，展示你的创意": "与更多品牌合作，展示你的创意",
  "登录/注册": "登录/注册",

  "消息": "消息",
  "环球客客服": "环球客客服",
  "系统消息": "系统消息",
  "按下Enter发送内容/ Ctrl+Enter换行": "按下Enter发送内容/ Ctrl+Enter换行",

  "用户政策": "用户政策",
  "隐私策略": "隐私策略",

  "找回密码": "找回密码",
  "已有账号": "已有账号？",

  "标签设置成功": "标签设置成功",
  "标签设置失败": "标签设置失败",
  "头像设置成功": "头像设置成功",
  "头像设置失败": "头像设置失败",
  "昵称设置成功": "昵称设置成功",
  "昵称设置失败": "昵称设置失败",
  "姓名设置成功": "姓名设置成功",
  "姓名设置失败": "姓名设置失败",
  "简介设置成功": "简介设置成功",
  "简介设置失败": "简介设置失败",

  "密码重置成功": "密码重置成功",
  "密码重置失败": "密码重置失败",

  "未认证": "未认证",
  "已提交认证": "已提交认证",
  "再次认证": "再次认证",
  "认证成功": "认证成功",
  "认证未通过": "认证未通过",

  "老用户提示信息": "亲爱的用户，请重置密码！",
  "验证码错误": "验证码错误",

  "裁剪图片": "裁剪图片",
  "京ICP备2023005886号-3": "京ICP备2023005886号-3",

  "保存草稿箱成功": "保存草稿箱成功",
  "保存草稿箱失败": "保存草稿箱失败",
  "更新草稿箱成功": "更新草稿箱成功",
  "更新草稿箱失败": "更新草稿箱失败",
  "草稿箱": "草稿箱",

  "在此登录": "在此登录",
  "在此注册": "在此注册",
  "系统通知": "系统通知",
  "系统通知引导内容": "接收平台信息，如项目提交结果等。",
  "客户服务": "客户服务",
  "客户服务引导内容": "如有任何疑问，请在此处联系我们。",
  "上传视频": "上传视频",
  "上传视频引导内容": "与我们分享您的高质量视频内容。",
  "探索任务": "探索任务",
  "探索任务引导内容": "探索最新任务，完成它并获得奖励。",
  "分享线索": "分享线索",
  "分享线索引导内容": "提供您认为有价值的故事、新闻等的线索。",
  "点击标题查看详情": "点击标题查看活动详情",
  "为本次活动做出贡献": "为本次活动做出贡献",
  "生成缩略图失败": "生成缩略图失败",
  "立即投稿": "立即投稿",
}
